export default {
    title: 'เข้าสู่ระบบชำระเงิน',
    login: 'เข้าสู่ระบบ',
    passwordHint: 'รหัสนักเรียน + วันเกิด เช่น T1234ววดดปปปป โดยใช้ปี ค.ศ.',
    schoolLabel: 'โรงเรียน',
    schoolPlaceholder: '- เลือกโรงเรียน -',
    usernameLabel: 'ชื่อ นามสกุล (นักเรียน)',
    usernamePlaceholder: 'ชื่อ นามสกุล',
    usernameRequired: 'ระบุเลขบัตรประชาชน / พาสฟอร์ต',
    passwordLabel: 'รหัสผ่าน',
    passwordPlaceholder: 'ระบุรหัสผ่าน',
    passwordRequired: 'ระบุรหัสผ่าน'
}
